import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserDto } from '../../model/user/user-dto';
import { SendOtpResult } from '../../model/send-otp-result';
import { NumberModel } from '../../model/user/number.model';
import { CardValidationModel } from '../../model/card.validation.model';
import { CreditCard } from '../../model/credit.card';
import { SendOtpPinResult } from 'src/app/model/send-otp-pin-result';

@Injectable({
  providedIn: 'root'
})
export class ValidationService extends BaseService {
  resourceUrl = 'validation';

  //Üye iş yerinin olusturduğu trackingId'yi kontrol eden servis.
  checkTrackingId(id: string): Observable<UserDto> {
    return this.get(`tracking/${id}`)
  }

  //Girilen telefon numarasını kontrol eden servis.
  checkPhoneNumber(phoneNumber: string, trackingId: string): Observable<SendOtpResult> {
    return this.get(`msisdn/${phoneNumber}/${trackingId}`);
  }

  //Girilen şifreyi kontrol eden servis.
  checkPin(numberModel: NumberModel, trackingId: string): Observable<SendOtpPinResult> {
    return this.post(`pin/${trackingId}`, numberModel);
  }

  //Girilen otp'yi kontrol eden servis.
  checkOtp(numberModel: NumberModel, trackingId: string): Observable<SendOtpResult> {
    return this.post(`otp/${trackingId}`, numberModel);
  }

  //Kullanıcının hesabını iptal eden servis(Sorulmalı ne olduğu)
  cancelAccount(trackingId: string): Observable<void> {
    return this.get(`account/cancel/${trackingId}`);
  }
  //Kullanıcı logout servis
  logout(): Observable<string> {
    return this.get(`logout`);
  }

  //Kullanıcının card validation için kartlarını çeken servis.
  getCardValidationModel(trackingId: string): Observable<CardValidationModel> {
    return this.get(`card/model/${trackingId}`);
  }

  //Kullanıcının card validation için kartlarını çektikten sonra hernangi bir kartın son kullanma tarihini doğruladıktan sonra çıkan servis.
  checkSkt(selectedCard: CreditCard, trackingId: string): Observable<void> {
    return this.post(`card/checkSkt/${trackingId}`, selectedCard);
  }

  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }

}
